module.exports = __webpack_public_path__ + "static/29-2bfdd0ea821f4c3bed6a03224ea74315.jpg";